import React, { useRef, useEffect, useCallback, useState} from 'react';
import {useScrollTo} from "components/selector2/useScrollTo.js";
import {usePacks} from "components/selector2/usePacks.js";
import Colors from 'components/Colors.js';
import Preset from "repos/Preset.js";
import TagsInfo from "components/installation/TagsInfo.js";
import ContentDropdown from "components/dropdowns/ContentDropdown.js";
import accounts from "accounts/Accounts.js"
import ethereum from 'decentralized/ethereum.js';
import {PRESET_RATED} from 'decentralized/xanadu/LinkTypes.js';
import PresetIcon from './getPresetStyle.js';
import Documented from 'components/help/Documented.js';
import {
    CHOOSE_INSTRUMENT_PRESET,
    FILTER_INSTRUMENT_TAG,
    INSTRUMENT_FX_LOAD ,
    INSTRUMENT_MODS_LOAD}  from 'constants/contextual-help.js';
import {connect} from 'react-redux';
import FavoriteButton from "components/FavoriteButton.js";

const colors = new Colors();

const PresetOption = ({
    scrollRef,
    currentPreset,
    preset,
    setPresetDragging,
    _auditionPreset,
    type=PRESET_RATED,
    isPianoRoll
}) => { 
    let [dropdownPos, setDropdownPos] = useState(undefined);
    let packsIncludedIn = preset.packs;
    let [isTagging, setIsTagging] = useState(false);

    let ref = useRef(undefined);

    useScrollTo({
        isCurrent: currentPreset && preset.contentHash === currentPreset.contentHash,
        ref,
        scrollRef,
        subtractContainer: true,
        topOffset: 20
    });

    const onContextMenu = useCallback((e) => {
        e.stopPropagation();
        let x = e.clientX - ref.current.getBoundingClientRect().left;
        let y = e.clientY - ref.current.getBoundingClientRect().top;
        if (x > 200) {
            x -= 200;
        }
        if (isPianoRoll) {
            x = e.clientX; 
            y = e.clientY;
        }
        x = Math.max(0, x);
        setDropdownPos({x,y});
        e.preventDefault();
    }, [setDropdownPos, isPianoRoll]);

    let className = preset.contentHash === currentPreset.contentHash ? "preset-option selected" : "preset-option";
    if (dropdownPos) {
        className += " showing-dropdown";
    }
    
    let tags = [...preset.tags, ...getTags(preset.title)];
    return (
        <div
          onContextMenu={onContextMenu}
          ref={ref}
        >
        <Documented
          element={CHOOSE_INSTRUMENT_PRESET}
          draggable={true}
          onDragStart={() => 
                       setPresetDragging(preset)}
          onClick={(e) => {
              if (e.ctrlKey) return; 
              _auditionPreset(preset);
          }}
          className={className}>
          <ContentDropdown
            setIsTagging={setIsTagging}
            dropdownPos={dropdownPos}
            setDropdownPos={setDropdownPos}
            type={PRESET_RATED}
            content={preset}
            setPackToSearch={() => []}
            contentHash={preset && preset.contentHash}/>
 
          <PresetIcon preset={preset}/>
          <span
            className="preset-name">{preset.title && preset.title.trim()} </span>
          {Array.from(new Set(packsIncludedIn)).map(
              pack =>
                  <div
                    style={{color: 'red', backgroundColor: colors.getColorForHash(pack)}}
                    className="pack-thumb"/>)}
          <span
            className="preset-tags">{tags.map(
                (tag, j) =>
                    <span key={j} className="preset-tag">{tag}</span>)}</span>
          {preset.favorited ? <div className="favorited heart"/> : ''}
        </Documented>
          {isTagging ?
           <TagsInfo
             content={new Preset().fromJson(preset, false)}
             onTag={(tag) => {
                 preset.tags.push(tag);
                 setIsTagging(false);
             }}/> : ''}
        </div>
    );
}


const TAGS = ["koto", "perc", "hi-hat", "kick", "snare", "clap", "poly", "mellotron", "clavinet", "arp", "bass", "bells", "drums", "flute", "guitar", "keys", "lead", "organ", "pad", "piano", "pluck", "stab", "strings", "rhodes", "electric-piano"];

const getTags = (name) => {
    name = name.toLowerCase();
    return TAGS.filter(
        tag => name.includes(tag));
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PresetOption);
